import { render, staticRenderFns } from "./TranslationPhraseModal.vue?vue&type=template&id=5c3eb642&scoped=true&"
import script from "./TranslationPhraseModal.vue?vue&type=script&lang=js&"
export * from "./TranslationPhraseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3eb642",
  null
  
)

export default component.exports